module.exports = __webpack_public_path__ + "img/home_en_primeur_it.9af7dd4.png";